import { FC, useMemo } from 'react'
import type { LocationResult } from '@alexanderathoodly/data-models'
import { Table, Tbody, Tr, Td, TableContainer } from '@chakra-ui/react'
import type { ChakraProps } from '@chakra-ui/react'
import { useSolutionDisplay } from './utils'
import { useTranslation } from 'react-i18next'

export const InfoTable: FC<{ location: LocationResult } & ChakraProps> = ({
	location,
	...rest
}) => {
	const { t } = useTranslation()
	const { cheapestSolution, smallestSolutionSize, largestSolutionSize } =
		useSolutionDisplay()
	const data = useMemo(() => {
		if (!cheapestSolution || !smallestSolutionSize || !largestSolutionSize) {
			return []
		}
		return [
			{
				text: t('Storlek på anläggningen'),
				value: `${location.size.toLocaleString('sv-SE')} m²`,
			},
			{
				text: t('Kontor från'),
				value: `${cheapestSolution} ${t('kr/person/månad')}`,
			},
			{
				text: t('Vilka kontor finns tillgängliga på anläggningen?'),
				value: `${
					smallestSolutionSize == 0
						? t('Just nu finns det inte några lediga kontor på anläggningen?')
						: t(
								'Det finns lediga kontor från {{smallest_solution_size}} {{unit}} - {{largest_solution_size}} arbetsplatser.',
								{
									smallest_solution_size: smallestSolutionSize,
									unit: t('Arbetsplats', {
										count: smallestSolutionSize,
									}).toLocaleLowerCase(),
									largest_solution_size: largestSolutionSize,
								}
						  )
				}`,
			},
		]
	}, [
		location.size,
		cheapestSolution,
		smallestSolutionSize,
		largestSolutionSize,
		t,
	])

	return (
		<TableContainer maxW={{ base: '90vw', md: '100vw' }} {...rest}>
			<Table size="sm">
				<Tbody>
					{data.map((d, i) => (
						<Tr key={i} backgroundColor={i % 2 == 0 ? 'blue.50' : ''}>
							<Td>{d.text}</Td>
							<Td>{d.value}</Td>
						</Tr>
					))}
				</Tbody>
			</Table>
		</TableContainer>
	)
}
